<template>
<div
:class="[isSubscriberOfPlus ? 'pt-20 pb-6' : 'pt-8']"
>
  <div class="bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 space-y-4 sm:p-6">
      
      <div class="flex justify-between items-end">
        <div
          class="relative"
          :class="[isSubscriberOfPlus ? '-mt-20 w-32 h-32' : '-mt-14 w-24 h-24']"
        >
          <img 
            :src="`${apiUrl}/tutor/${id}/photo`" 
            class="rounded-full border-2 border-white"
            :class="[isSubscriberOfPlus ? '' : 'filter grayscale brightness-125']"
          />

          <component
            v-if="profileBadge !== null"
            :is="profileBadge.component"
            class="absolute -bottom-0.5 -right-0.5 cursor-help"
            :class="[isSubscriberOfPlus ? 'w-9 h-9' : 'w-6 h-6', profileBadge.class]"
            @click.native="dbsModalOpen = true"
          />
        </div>

        <div class="flex items-center space-x-4">
          <component
            :is="favourited ? 'StarSolidIcon' : 'StarOutlineIcon'" 
            @click="$emit('toggleFavourite')"
            class="w-6 h-6" 
            :class="favourited ? 'text-yellow-500' : 'text-gray-400'"
          />

          <router-link 
            :to="publicProfileUrl"
            class="inline-flex justify-center items-center w-30 px-1 py-2 group border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <span>View Profile</span>
            <ChevronRightIcon class="w-0 h-5 transition-all group-hover:w-5" />
          </router-link>
        </div>
      </div>

      <div class="space-y-0">
        <h2
          class="text-gray-800 truncate"
          :class="[isSubscriberOfPlus ? 'text-xl font-semibold' : 'text-lg font-medium']"
        >
          {{ name }}
        </h2>
        <p v-if="qualification" class="text-sm text-gray-400 font-medium truncate">
          {{ qualification.Level }} {{ qualification.Subject }}
        </p>
      </div>

      <div class="flex justify-between items-center">
        <div v-if="rate" class="font-medium">
          <span class="text-lg text-gray-800">£{{ rate }}</span>
          &nbsp;
          <span class="text-sm text-gray-400">per hour</span>
        </div>
        <div v-else><!--Placeholder for flex layout--></div>

        <div class="flex items-baseline space-x-3">
          <div v-if="location" class="flex items-center space-x-1">
            <LocationMarkerIcon class="w-5 h-5 text-gray-400" />
            <span class="text-sm text-gray-500 font-medium">{{ location }}</span>
          </div>

          <div v-if="teachesOnline" class="flex items-center space-x-1">
            <DesktopComputerIcon class="w-5 h-5 text-gray-400" />
            <span class="text-sm text-gray-500 font-medium">Online</span>
          </div>
        </div>
      </div>

      <div
        class="leading-relaxed"
        :class="[isSubscriberOfPlus ? 'text-sm text-gray-600' : 'text-xs text-gray-500']"
      >
        {{ shortenedBio }}
      </div>

      <PayWithStripeBadge v-if="acceptsStripePayments" />

      <div v-if="isSubscriberOfPlus && testimonial" class="pt-1">
        <div class="pt-3 border-t border-gray-100 text-xs text-gray-600 font-medium italic leading-relaxed">
          “{{ shortenedTestimonial }}”
        </div>
      </div>

    </div>
  </div>


  <DbsModal
    v-if="dbsModalOpen"
    @close="dbsModalOpen = false"
  />

</div>

    <!-- <div>

        <img src="https://placehold.it/75x75" />
        <div style="text-align: left">
            <router-link :to="`/${result.TutorsId}`" style="font-size: 18px; font-weight: 700;">{{ result.TutorsName }}</router-link>
            <div>Teaches: <span v-for="(subject, index) in result.TutorsSubjects" :key="index + 1">{{ subject }}, </span></div>
        </div>

    </div> -->
</template>
<script>
import { StarIcon as StarOutlineIcon } from '@vue-hero-icons/outline'
import { 
  StarIcon as StarSolidIcon, 
  ChevronRightIcon, 
  LocationMarkerIcon, 
  DesktopComputerIcon,
  LockClosedIcon,
  ShieldCheckIcon,
} from '@vue-hero-icons/solid'
import CheckCircleIcon from './CheckCircleIcon.vue'
import CheckShieldIcon from './CheckShieldIcon.vue'
import CheckShieldBadgeIcon from './CheckShieldBadgeIcon.vue'
import StripeLogo from './StripeLogo.vue'
import PayWithStripeBadge from './PayWithStripeBadge.vue'
import DbsModal from './DbsModal.vue'

const bioLength = 140
const bioLengthSubscriberPlus = 280
const testimonialLength = 180

export default {
  components: {
    StarOutlineIcon,
    StarSolidIcon,
    ChevronRightIcon,
    LocationMarkerIcon,
    DesktopComputerIcon,
    CheckCircleIcon,
    CheckShieldIcon,
    CheckShieldBadgeIcon,
    StripeLogo,
    LockClosedIcon,
    PayWithStripeBadge,
    ShieldCheckIcon,
    DbsModal,
  },
  props: {
    id: String,
    name: String,
    qualification: Object,
    rate: [String, Number],
    bio: String,
    photo: String,
    favourited: Boolean,
    verifiedStatus: String,
    teachesOnline: Boolean,
    location: String,
    acceptsStripePayments: Boolean,
    isSubscriberOfPlus: Boolean,
    testimonial: String,
  },
  data() {
    return {
      dbsModalOpen: false,
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_BASE_URL
    },
    profileBadge() {
      switch (this.verifiedStatus) {
        case 'ID':
          return {
            component: CheckCircleIcon,
            class: ''
          }
      
        case 'DBS':
          return {
            component: CheckShieldIcon,
            class: ''
          }

        case 'TutorAssessment': {
          return {
            component: CheckShieldBadgeIcon
          }
        }

        default:
          return null
      }
    },
    shortenedBio() {
      return shortenString(
        this.bio, 
        this.isSubscriberOfPlus ? bioLengthSubscriberPlus : bioLength
      )
    },
    qualificationString() {
      return `${this.qualification?.Level} ${this.qualification?.Subject}`
    },
    publicProfileUrl() {
      return `${ this.id }-${ this.name.replace(/ /g, '-').toLowerCase() }`
    },
    shortenedTestimonial() {
      return shortenString(
        this.testimonial,
        testimonialLength
      )
    }
  }
}

function shortenString(str, maxLength) {
  if (str.length <= maxLength) return str
  const fullStopIndex = findFullStopPosition(str, 0, maxLength)

  return fullStopIndex
    ? str.substring(0, fullStopIndex + 1)
    : str.substring(0, maxLength) + '…'
}

function findFullStopPosition(str, startAt, maxLength) {
  const index = str.indexOf('.', startAt)

  if (index === -1) 
    // No full stops to grab index of, so truncate
    return false
  if (index < maxLength)
    // Index of full stop is less than the minimum length so keep searching
    return findFullStopPosition(str, index + 1, maxLength)
  else 
    // Found our full stop, return it's index
    return index
}
 
</script>
<style lang="scss" scoped>

</style>